import React from 'react';
import styled from 'styled-components';
import Icon from '../icon';
import { defaultTheme } from '../../data/themes';


const Items = styled.div`
	position: absolute;
	z-index: 1000;
	left: 100%;
	top: 0px;
	box-shadow: 0 0 20px 0 rgba(0,0,0,0.05);
	text-align: left;
	background: ${props => props.theme.accordionBackground || defaultTheme.accordionBackground};
`;

const ItemHeader = styled.div`
	white-space: nowrap;
	font-size: ${props => props.theme.accordionHeaderFontSize || defaultTheme.accordionHeaderFontSize};
	padding: 8px;
	border-bottom: ${props => props.theme.accordionFolderSeparator || defaultTheme.accordionFolderSeparator};
	font-weight: ${props => props.theme.accordionExpandedHeaderFontWeight || defaultTheme.accordionExpandedHeaderFontWeight};
`;
//	color: ${props => props.theme.accordionExpandedHeaderColor || defaultTheme.accordionExpandedHeaderColor};

const Folder = styled.div`
	position: relative;
	overflow: visible;
	cursor:pointer;
	text-align: center;
	&.expanded {
		color: ${props => props.theme.accordionExpandedHeaderColor || defaultTheme.accordionExpandedHeaderColor};
		${ItemHeader} {
			color: ${props => props.theme.accordionExpandedHeaderColor || defaultTheme.accordionExpandedHeaderColor};
		}
	}
	&:hover {
		background: ${props => props.theme.tableRowHoverBackground};
	}
`;

const Item = styled.div`
	white-space: nowrap;
	color: ${props => props.theme.accordionItemColor || defaultTheme.accordionItemColor};
	font-size: ${props => props.theme.accordionItemFontSize || defaultTheme.accordionItemFontSize};
	font-weight: ${props => props.theme.accordionItemFontWeight || defaultTheme.accordionItemFontWeight};
	padding: 4px 8px;
	cursor:pointer;
	&:hover {
		text-decoration: ${props => props.theme.accordionHoverItemTextDecoration || defaultTheme.accordionHoverItemTextDecoration};
	}
	&.selected {
		color: ${props => props.theme.accordionSelectedItemColor || defaultTheme.accordionSelectedItemColor};
		font-weight: ${props => props.theme.accordionSelectedItemFontWeight || defaultTheme.accordionSelectedItemFontWeight};
	}

`;

const Wrapper = styled.div`
	overflow: visible;
	background: ${props => props.theme.accordionBackground || defaultTheme.accordionBackground};
	box-shadow: 0 0 20px 0 rgba(0,0,0,0.05);
	&.vertical {
		height: 100%;
		${Folder} {
			padding: 8px;
			border-bottom: ${props => props.theme.accordionFolderSeparator || defaultTheme.accordionFolderSeparator};
		}
	}
`;


export default class SimpleIconMenu extends React.PureComponent {
	constructor() {
		super();
		this.state = {};
		this.onMouseDown = this.onMouseDown.bind(this);
		this.containerRef = React.createRef();
	}

	showItems(folderIndex) {
		this.setState({
			openFolderIndex: folderIndex
		});
	}

	hideItems() {
		this.setState({
			openFolderIndex: null
		})
	}

	onMouseDown = function(e) {
		if (typeof this.state.openFolderIndex !== 'number') {
			return;
		}
		const container = this.containerRef.current;
		let el = e.target;
		if (el !== container) {
			while ((el = el.parentElement)) {
				if (el === container) {
					return;
				}
			}
			this.hideItems();
		}
	}

	onItemSelected(folderName, itemName) {
		this.hideItems();
		if (this.props.onItemSelected) {
			this.props.onItemSelected(folderName, itemName);
		}
	}

	onFolderExpanded(folderName) {
		if (this.props.onFolderExpanded) {
			this.props.onFolderExpanded(folderName);
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.onMouseDown);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onMouseDown);
	}

	render() {
		const expandedFolderName = this.props.expandedFolderName;
		const selectedFolderName = this.props.selectedFolderName;
		const selectedItemName = this.props.selectedItemName;
		return (
			<Wrapper className="vertical" ref={this.containerRef}>
				{
					(this.props.folders || EMPTY_LIST).map((folder, folderIndex) => {
						const folderName = folder.get('name');
						const expanded = folderName === expandedFolderName;
						const selectedFolder = folderName === selectedFolderName;
						return (
							<Folder
								key={folderIndex}
								className={'ps-iconMenuFolder' + (expanded ? ' expanded' : '')}
								onMouseDown={e => {
									if (this.state.openFolderIndex !== folderIndex) {
										this.showItems(folderIndex);
										this.onFolderExpanded(folderName);
									} else {
										this.hideItems();
									}
								}}
							>
								<Icon
									name={folder.get('icon')}
								/>
								{
									folderIndex === this.state.openFolderIndex && (
										<Items>
											<ItemHeader>{folder.get('text')}</ItemHeader>
											{
												(folder.get('items') || EMPTY_LIST).map((item, itemIndex) => {
													const selected = selectedFolder && item.get('name') === selectedItemName;
													return (
														<Item
															key={itemIndex}
															className={'ps-iconMenuItem' + (selected ? ' selected' : '')}
															onMouseDown={e => {
																e.preventDefault();
																this.onItemSelected(folderName, item.get('name'));
															}}
															data-name={item.get('name')}
														>
															<span className="text">{item.get('text')}</span>
														</Item>
													)
												})
											}
										</Items>
									)
								}
							</Folder>
						);
					})
				}
			</Wrapper>
		)
	}
}